import {useLoaderData, useParams, useRouteError} from "react-router-dom";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {getAttribute} from "../../components/common/utilities";
import {Tab} from "@headlessui/react";
import SidebarNavigation from "../../components/common/sidebarnavigation.component";
import LoginPage from "./loginPage";
import CreatePage from "./createUser";

export default function ViewInvite() {

    let params = useParams();
    const venueID = params.guid;
    const data = useLoaderData();
    console.log(data);
    const [teamList, setTeamList] = useState([])
    let [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState(null);
    const [statusMessage, setStatusMessage] = useState(null);
    const [detailStatusMessage, setDetailStatusMessage] = useState(null);
    useEffect(() => {

        //setTeamList(data)

    }, []);



    const verifyInvite = async () => {
        axios.post(`${process.env.REACT_APP_API_URL}/p/user/verifyinvite.do`, {
            instance: 'promogogo', ticket: localStorage.getItem('ticket'), token: params.token
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   }).then(function (response) {
            // handle success
            console.log(response);
            window.location.href = '/dashboard';

        }).catch(function (error) {
            console.log(error);
            setStatusMessage(error.message)
            setDetailStatusMessage(error.response.data.error)
        });

    }

    return (

            <div className="min-h-full">
                <SidebarNavigation/>

                <div className="bg-white ">
                    <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-12 lg:max-w-3xl lg:px-8">
                        <div className="mt-2">
                            <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow">
                                <div className="px-4 py-5 sm:px-6">
                                    {/* Content goes here */}
                                    {/* We use less vertical padding on card headers on desktop than on body sections */}
                                    <h1 className="text-2xl tracking-tight text-gray-500">Team</h1>
                                </div>
                                <div className="px-4 py-5 sm:p-6">

                                    <div className="mx-auto mt-6 max-w-2xl leading-8">

                                        <div className="mt-2">
                                            <h1 className="text-2xl tracking-tight text-gray-500">{data.title}</h1>
                                        </div>
                                        <p className={'mt-2'}>
                                            {getAttribute(data,'invitedby')} invited you to join the {getAttribute(data,'inviteproperty')} team.
                                        </p>
                                        {!localStorage.getItem('ticket') && (
                                                <div className={'mt-2'}>
                                                    <Tab.Group>
                                                        <Tab.List className="isolate flex divide-x divide-gray-200 rounded-lg shadow" aria-label="Tabs">
                                                            {tabs.map((tab,index) => (
                                                                    <Tab key={index}
                                                                         className={classNames(
                                                                                 tab.current ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700',
                                                                                 index === 0 ? 'rounded-l-lg' : '',
                                                                                 index === tabs.length - 1 ? 'rounded-r-lg' : '',
                                                                                 'ui-selected:border-indigo-600 group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10'
                                                                         )}
                                                                    >{tab.name}</Tab>
                                                            ))}

                                                        </Tab.List>
                                                        <Tab.Panels>
                                                            {tabs.map((tab,index) => (
                                                                    <Tab.Panel key={'tabpanel'+index}>

                                                                        {tab.view === 'login' && (
                                                                                <LoginPage/>
                                                                        )}

                                                                        {tab.view === 'create' && (
                                                                                <CreatePage/>
                                                                        )}



                                                                    </Tab.Panel>
                                                            ))}
                                                        </Tab.Panels>
                                                    </Tab.Group>
                                                </div>
                                        )}
                                        {localStorage.getItem('ticket') && (
                                                <div>
                                                    <button className={'bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded'} onClick={verifyInvite}>Accept Invite</button>
                                                </div>
                                        )}




                                    </div>

                                    <div className="mt-2">

                                        <div className="mt-2">

                                        </div>


                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="mx-auto max-w-2xl px-4 py-4 sm:px-6 sm:py-4 lg:max-w-3xl lg:px-8">

                    </div>
                </div>
            </div>)
}
